import { lazy, Suspense } from 'react';
import CustomAppBanner from './CustomAppBanner';

const CustomAppNeed = lazy(() => import("./CustomAppNeed"));
const CustomEnterprises = lazy(() => import("./CustomEnterprises"));
const WhyCustomApp = lazy(() => import("./WhyCustomApp"));
const CustomCycle = lazy(() => import("./CustomCycle"));
const CustomTools = lazy(() => import("./CustomTools"));
const CustomTech = lazy(() => import("./CustomTech"));
const ShuttleAppreciation = lazy(() => import("../shuttle_software/ShuttleAppreciation"));
const ShuttleItNeed = lazy(() => import("../shuttle_software/ShuttleItNeed"));
const TaxiFaq = lazy(() => import("../taxiDispatchSoftware/TaxiFaq"));
const OnDemandWork = lazy(() => import('../cloneApps/onDemand/OnDemandWork'));

const faqData = [
  {
    id: "0",
    question: "01. What is custom software development?",
    answer: "Custom software development involves creating tailored software solutions to meet the unique needs of your organization. Unlike generic products that may require process adjustments, custom solutions integrate seamlessly with your operations, enhancing efficiency and providing full control and ownership.",
  },
  {
    id: "1",
    question: "02. How is ROI calculated, and how long does it take to see a return on investment?",
    answer: "The ROI for custom software is calculated by comparing total expenses to the financial benefits and efficiency improvements it offers over time. The payback period varies based on project size, operational efficiencies, and the software's impact on business performance.",
  },
  {
    id: "2",
    question: "03. What is the process for developing scalable and easily maintainable custom software?",
    answer: "Creating scalable and maintainable software requires foresight for future growth. A well-designed architecture handles increased workloads smoothly, minimizing major redesigns. Employing modular designs, cloud computing, and continuous maintenance keeps the software flexible and efficient as it evolves.",
  },
  {
    id: "3",
    question: "04. Can I transfer the support and maintenance of custom software to another vendor?",
    answer: "Transferring support and maintenance of custom software to another vendor is feasible, but it's essential to ensure the new vendor has the required technical skills and a thorough understanding of the software's architecture for effective support and updates.",
  },
  {
    id: "4",
    question: "05. Why choose custom software over off-the-shelf products?",
    answer: "Custom software is tailored to your organization, boosting efficiency and productivity beyond generic solutions that may not meet your needs. By opting for a bespoke solution, businesses can avoid the limitations of standard products, ensuring the software aligns with their unique workflows and supports future growth.",
  },
  {
    id: "5",
    question: "06. Do you offer post-development support for custom software?",
    answer: "We provide comprehensive post-launch support, including updates, bug fixes, performance tracking, and enhancements as your business evolves.",
  }
];

export default function CustomAppDevelopment() {
  return (
    <>
      <CustomAppBanner />

      <Suspense fallback={null}>
        <CustomAppNeed />
        <CustomEnterprises />
        <CustomCycle />
        <WhyCustomApp />
        <CustomTools />
        <CustomTech />
        <div className="solution-case">
          <OnDemandWork />
        </div>
        <ShuttleAppreciation />
        <ShuttleItNeed />
        <TaxiFaq faqData={faqData} />
      </Suspense>
    </>
  );
}